// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__L2DeF","list":"PatternAutocomplete_list__b3rOY"};